import { getLocale } from "../runtime";

const sv_becountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Belgium`
};

const becountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_becountryenglish(inputs)
	return "beCountryEnglish";
};

export { becountryenglish as "beCountryEnglish" };